import { Injectable } from '@angular/core';
import { Base2Service } from '../base2.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { clientBookingData } from 'src/app/models/interfaces/interfaces';
import { BaseclientService } from '../../apiclient/baseclient.service';

@Injectable({
  providedIn: 'root'
})

export class TableReservationService {

  constructor(
    private base2: Base2Service,
    private baseClient: BaseclientService
  ) { }


  /**
   * @description Récupère les parametres de réservation de table en fonction du point de vente
   * @param {number} posId Id du point de vente
   * @param {string} userKey Clé commerçant
   * @return {Promise}
   */
  getBookingSettings(posId: number, userKey?: string): Promise<any> {

    const params = {
      id_point_of_sale: posId
    }

    return this.base2.getBase("booking_settings", params, userKey);
  }


  getBookingMeta(webshopId: string | number) {
    const params = { id_point_of_sale: webshopId };
    return this.base2.getBase("booking_meta", params, null, true);
  }




  $_getBookingSettings(webshopId: string | number): Promise<any> {
    const params = { id_webshop: webshopId };
    return this.baseClient.postBaseApi("booking_settings", params);
  }


  $_getBookingMeta(webshopId: string | number) {
    const params = { id_webshop: webshopId };
    return this.baseClient.postBaseApi("booking_meta", params);
  }


}
